import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import {useLinkResolver} from 'prismicio'
import type {BannerV2SliceFullWidth} from 'prismicio-types'
import {ButtonV2} from 'src/common/ButtonV2'
import {Container} from 'src/common/Container'
import {ResponsiveImage} from '../components/ResponsiveImage'

type FullWidthVariationProps = {
  slice: BannerV2SliceFullWidth & {slice_type: string; variation: string}
  index: number
  pageUid: string
}

export const FullWidthVariation = ({slice, index, pageUid}: FullWidthVariationProps) => {
  const {linkResolver} = useLinkResolver()

  return (
    <Container className="!py-0" backgroundColor={slice.primary.background_color}>
      <div className="mx-auto flex w-full max-w-container justify-between gap-12 overflow-hidden rounded-lg bg-green-neon py-0 max-lg:flex-col md:max-lg:gap-0 lg:items-center lg:px-5 xl:px-0">
        {/* Left content section */}
        <div className="flex w-full max-w-[416px] flex-1 flex-col gap-6 px-5 max-lg:pt-6 md:pl-10 md:pr-0 md:max-lg:max-w-[60%] lg:px-0">
          <div className="flex flex-col gap-2">
            <PrismicRichText
              field={slice.primary.title}
              components={{
                heading3: ({children}) => (
                  <h3 className="text-[32px] font-medium leading-[38px] text-moss-black">{children}</h3>
                ),
              }}
            />
            <PrismicRichText
              field={slice.primary.description}
              components={{
                paragraph: ({children}) => <p className="text-tg-body-l text-black/60">{children}</p>,
              }}
            />
          </div>

          {isFilled.link(slice.primary.button_link) && (
            <ButtonV2
              variant="secondary"
              size="medium"
              href={linkResolver(slice.primary.button_link)}
              trackingData={{
                pageName: pageUid,
                location: `${slice.slice_type}-${index}`,
                dataType: 'primary-button',
                mktgId: 'banner-fullwidth',
              }}
              className="w-fit !bg-green-dark text-moss-white hover:!bg-green-dark/80"
            >
              {slice.primary.button_link.text}
            </ButtonV2>
          )}
        </div>

        <ResponsiveImage
          image={slice.primary.image}
          pictureClassName="w-full shrink-0 overflow-hidden rounded-sm lg:max-w-[669px]"
          mobileClassName="md:hidden"
          desktopClassName="object-cover max-md:hidden md:max-lg:px-10"
        />
      </div>
    </Container>
  )
}
